import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { ReservationApiService } from '../apis/reservation-api.service';
import { EOrder, EOrderLine } from '../model/reservation';
import { LocalStorageService } from '../lib/local-storage.service';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import * as AppActions from '../store/actions/app.actions';
import * as ReservationListActions from '../store/actions/reservation-list.actions';


@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit {
  @ViewChild('modal') modal!: ModalDialogComponent;
   
  order: EOrder | null = null;
  lang: string = "eng";

  constructor(private service: ReservationApiService,
    private storage: LocalStorageService,
    private translateService: TranslateService,
    private store: Store,
  ) { }

  ngOnInit(): void {    
    
  }

  setLang() {
    var appLang = this.storage.getLanguage();
    this.lang = appLang == "el" ? "ell" : "eng";
  }

  show(rsvId: string) {    
    this.setLang();
    
    this.service.getOrderDetails(rsvId).subscribe({
      next: (order)=> {      
        this.order = order;
        this.modal.show();
      }, 
      error: ()=> {
        this.store.dispatch({ type: AppActions.showAlert.type, alert: this.translateService.instant('orderDetails.error') });
      }
    });
  }

  getProductTitle(line: EOrderLine) {
    var prd = this.getProductFromLine(line);
    
    return this.trans(prd.title, this.lang);
  }

  getProductFromLine(line: EOrderLine):any {
    return JSON.parse(line.productJson);
  }

  trans(what: string, lang: string) {
    try {                                                
        var json = JSON.parse(what);
        var trans = json[lang];

        if (trans == null || trans.trim() == "") throw new Error('Could not translate!');;

        return trans;
    }
    catch {
        var json = JSON.parse(what);
        var firstLang = Object.keys(json)[0];
        return json[firstLang];
    }    
  }

  onClose() {
    this.store.dispatch({ type: ReservationListActions.setOrderDetailsReservation.type, reservationId: null });
  }
  
}
